import { render, staticRenderFns } from "./UserPaperPreview.vue?vue&type=template&id=2d4e18f6&scoped=true"
import script from "./UserPaperPreview.vue?vue&type=script&lang=js"
export * from "./UserPaperPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPaperPreview.vue?vue&type=style&index=0&id=2d4e18f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e18f6",
  null
  
)

export default component.exports